module.exports = __webpack_public_path__ + "static/media/Automotive.a0a82561.svg";